import type {
  CreateBrandInput,
  UpdateBrandInput,
} from "@src/__generated__/urql-graphql";
import type { WorkspaceSettings } from "@src/stores/models/WorkspaceSettings";
import { maxLength, onlyNumeric, required } from "@src/utils/forms/validators";
import { FieldState, FormState } from "formstate";

export class FormBrand {
  name = new FieldState("").validators(required);
  code = new FieldState("").validators(required, maxLength(10));
  numeric_code = new FieldState("").validators(onlyNumeric);
  photo = new FieldState<File | null | "delete">(null);
  client_id = new FieldState("").validators(required);
  default_billing_entity_id = new FieldState<string | undefined>(undefined);
  update_project_codes = new FieldState(false);

  _form = new FormState([
    this.name,
    this.code,
    this.numeric_code,
    this.client_id,
    this.default_billing_entity_id,
    this.update_project_codes,
  ]);

  constructor(private workspaceSettings: WorkspaceSettings | undefined) {}

  validate(options?: { withClient: boolean }) {
    const fields = [this.name, this.code, this.default_billing_entity_id];

    if (options?.withClient) {
      fields.push(this.client_id);
    }

    if (this.workspaceSettings?.enableAdditionalBrandNumericCode) {
      fields.push(this.numeric_code);
    }

    const formToValidate = new FormState(fields);

    return formToValidate.validate();
  }

  serializeForCreate(): CreateBrandInput {
    return {
      name: this.name.value,
      code: this.code.value,
      numeric_code: this.numeric_code.value,
      photo: this.photo.value || null,
      client_id: this.client_id.value,
      default_billing_entity_id: this.default_billing_entity_id.value,
    };
  }

  serializeForUpdate(id: string): UpdateBrandInput {
    const baseInput = {
      id,
      name: this.name.value,
      code: this.code.value,
      numeric_code: this.numeric_code.value,
      default_billing_entity_id: this.default_billing_entity_id.value,
      update_project_codes: this.update_project_codes.value,
    };

    if (!this.photo.value) {
      return baseInput;
    }

    return {
      ...baseInput,
      photo: this.photo.value === "delete" ? null : this.photo.value,
    };
  }
}
